// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3hss7","nft-name":"classes_nft-name__qud_u"};